import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import About from '@/pages/about/about'
import GettingStarted from '@/pages/getting-started/getting-started'
import Treatments from '@/pages/treatments/treatments'
import Invisalign from '@/pages/invisalign/invisalign'
import Braces from '@/pages/braces/braces'
import Contact from '@/pages/contact/contact'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      description: 'Home page description',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/getting-started',
      name: 'getting-started',
      component: GettingStarted
    },
    {
      path: '/treatments',
      name: 'treatments',
      component: Treatments
    },
    {
      path: '/invisalign',
      name: 'invisalign',
      component: Invisalign
    },
    {
      path: '/braces',
      name: 'braces',
      component: Braces
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      component: ThankYou
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      component: Accessibility
    },
    {
      path: '/*',
      name: 'page-not-found',
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js